import PropTypes from 'prop-types';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { unitToString } from '@/utils/unitUtils';
import { getGeography } from './ecoinventUtils';

const CurrentSelection = ({ selectedItem, onClear }) => {
  return (
    <div className="border rounded-lg overflow-hidden min-h-16">
      <div className="bg-gray-50 flex items-center justify-between p-3">
        <h4 className="font-medium text-xs">Current Selection</h4>
        {selectedItem && (
          <button className="btn btn-ghost btn-xs btn-square" onClick={onClear}>
            <XMarkIcon className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="p-4">
        {selectedItem ? (
          <div className="flex gap-2 flex-col">
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 font-semibold">Version:</span>
              <span className="badge bg-blue-100 text-xs p-3 rounded-md">v3.11</span>
            </div>

            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 font-semibold">Activity:</span>
              <span className="badge bg-green-100 text-xs p-3 rounded-md">
                {selectedItem.dataset?.metadata?.ecoinvent_activity_name}
              </span>
            </div>

            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 font-semibold">Geography:</span>
              <span className="badge bg-purple-100 text-xs p-3 rounded-md">{getGeography(selectedItem)}</span>
            </div>

            <p className="text-sm text-gray-700">{selectedItem.dataset?.description}</p>

            <div className="text-sm">
              <span className="text-gray-600 font-semibold">Source:</span>
              <span className="ml-2">Ecoinvent v3.11 - {selectedItem.dataset?.metadata?.ecoinvent_activity_name}</span>
            </div>

            <div className="text-sm">
              <span className="text-gray-600 font-semibold">URL:</span>
              <span className="ml-2">
                <a
                  href={selectedItem.dataset?.metadata?.ecoinvent_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline text-sm"
                >
                  {selectedItem.dataset?.metadata?.ecoinvent_url}
                </a>
              </span>
            </div>

            <div className="text-sm">
              <span className="text-gray-600 font-semibold">Value:</span>
              <span className="ml-2 font-medium text-blue-600">{selectedItem?.value?.toFixed(3)}</span>
            </div>

            <div className="text-sm">
              <span className="text-gray-600 font-semibold">Reference Product:</span>
              <span className="ml-2">{selectedItem.dataset?.metadata?.ecoingent_reference_product}</span>
            </div>

            <div className="text-sm">
              <span className="text-gray-600 font-semibold">Unit:</span>
              <span className="ml-2">{unitToString(selectedItem.unit)}</span>
            </div>
          </div>
        ) : (
          <div className="text-gray-500 text-center flex items-center justify-center h-16">
            <div>
              <p>No dataset selected. Click &quot;Select&quot; on a dataset below to see details here.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CurrentSelection.propTypes = {
  selectedItem: PropTypes.object,
  onClear: PropTypes.func.isRequired,
};

export default CurrentSelection;
